<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs4>
                        <v-select :items="pspList" label="Select a gateway" @change="pspHandle"></v-select>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs4>
                        <v-select :disabled="!state" v-model="clearingInstitute" :items="clearingInstitutesList" label="Select a clearing institute"></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <onboarding-form v-if="clearingInstitute" :state="state" :clearingInstitute="clearingInstitute"></onboarding-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template> 

<script>
    import OnBoardingForm from '../components/OnBoardingForm.vue';
    import sweetAlert from '../sweetAlert.js';
    import axios from 'axios';

    export default {
        data () {
            return {
                state: null,
                clearingInstitute: null,
                clearingInstitutesList: [],
                clearingInstitutesListLive: [{ value: 'Bambora (via Evry)', text: 'Bambora (via Evry)' },
                                             { value: 'BSCardServices', text: 'BS PAYONE' },
                                             { value: 'Voice Commerce Group', text: 'Cashflows' },
                                             { value: 'Concardis', text: 'Concardis' },
                                             { value: 'Optimalpayment', text: 'Paysafe' },
                                             { value: 'Securetrading_Omnipay', text: 'Secure Trading' },
                                             { value: 'Wirecard', text: 'Wirecard' },
                                             { value: 'Worldline', text: 'Worldline' }],

                clearingInstitutesListTest: [{ value: 'Bambora (via Evry)', text: 'Bambora (via Evry)' },
                                             { value: 'B+S Card Service Test', text: 'BS PAYONE' },
                                             { value: 'VCG Test', text: 'Cashflows' },
                                             { value: 'Concardis Test', text: 'Concardis' },
                                             { value: 'Optimalpayment Test', text: 'Paysafe' },
                                             { value: 'SecureTrading Omnipay Demo', text: 'Secure Trading' },
                                             { value: 'Wirecard Test', text: 'Wirecard' },
                                             { value: 'Worldline Test', text: 'Worldline' }],

                pspList: [{ value: 'Live', text: 'Live' },
                          { value: 'Test', text: 'Test' }]
            }
        },
        components: {
           'onboarding-form' : OnBoardingForm
        },
        methods: {
            pspHandle(value) {
                this.state = value;
                this.clearingInstitute = null;
                this.clearingInstitutesList = value == 'Live' ? this.clearingInstitutesListLive : this.clearingInstitutesListTest;
            }
        }
    }
</script>

<style>
 
</style>
